import { Component } from "@angular/core";

@Component({
    selector: "app-modal-document-type",
    templateUrl: "./modal-document-type.component.html",
    styleUrls: ["./modal-document-type.component.scss"],
    standalone: false
})
export class ModalDocumentTypeComponent {
  public data: any;
  index: number = 1;
  documentsImg: any = [
    {
      img: "assets/tramite-pensiones/cert-nacimiento.png",
      alt: "certificado de nacimiento",
    },
    {
      img: "assets/tramite-pensiones/cert-conyuge.png",
      alt: "certificado de conyuge",
    },
    {
      img: "assets/tramite-pensiones/cert-matrimonio.png",
      alt: "certificado de matrimonio",
    },
    {
      img: "assets/tramite-pensiones/cert-union-civil.png",
      alt: "certificado de union_civil",
    },
  ];

  btnNext() {
    if (this.index < 4) {
      this.index++;
    }
  }

  btnback() {
    if (this.index > 1) {
      this.index--;
    }
  }
}
